/* eslint-disable react/prop-types */
import React from 'react';
import { Form } from 'react-bootstrap';

const CreateTutorialForm = ({ titulo, setTitulo, setFile, date, setDate }) => {
  const handleTitleChange = e => setTitulo(e.target.value);

  const handleFileChange = e => {
    if (e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  const handleDateChange = e => setDate(new Date(e.target.value));

  return (
    <Form>
      <Form.Group>
        <Form.Label>Título</Form.Label>
        <Form.Control
          type="text"
          placeholder="Ingresa el título"
          value={titulo}
          onChange={handleTitleChange}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Fecha de publicación</Form.Label>
        <Form.Control
          type="date"
          value={date.toISOString().split('T')[0]} // Convertir la fecha a formato 'YYYY-MM-DD'
          onChange={handleDateChange}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Cargar PDF</Form.Label>
        <Form.Control type="file" onChange={handleFileChange} accept=".pdf" />
      </Form.Group>
    </Form>
  );
};

export default CreateTutorialForm;
